var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.966 0H1.034A1.033 1.033 0 0 0 0 1.033v11.934A1.033 1.033 0 0 0 1.033 14h11.934A1.034 1.034 0 0 0 14 12.966V1.034A1.034 1.034 0 0 0 12.966 0ZM4.174 11.926H2.068V5.24h2.105v6.686ZM3.119 4.314a1.209 1.209 0 1 1 1.215-1.208A1.19 1.19 0 0 1 3.12 4.314Zm8.812 7.618H9.827V8.28c0-1.077-.458-1.41-1.049-1.41-.624 0-1.236.471-1.236 1.438v3.625H5.437V5.245H7.46v.927h.027c.203-.412.915-1.114 2-1.114 1.175 0 2.444.697 2.444 2.738v4.136Z",
    fill: "#D9D9D9"
  })));
};

export default SvgLinkedin;